<template>
    <div
        class="tw-h-2 tw-w-full tw-overflow-hidden tw-rounded-full tw-bg-slate-200 tw-shadow-inner"
        role="progressbar"
        :aria-valuenow="progress"
        aria-valuemin="0"
        aria-valuemax="100"
    >
        <div
            class="tw-flex tw-h-full tw-items-center tw-justify-center tw-rounded-full tw-bg-green-500 tw-text-center tw-text-white tw-transition-[width] tw-duration-300 tw-ease-out"
            :style="`width:${progress}%`"
        >
            <slot></slot>
        </div>
    </div>
</template>

<script setup>
defineProps({
    progress: {
        type: Number,
        required: true,
        validator(val) {
            return val >= 0 && val <= 100;
        },
    },
});
</script>
